import React, { useState, useEffect } from "react";
import classNames from "classnames";
import cx from "classnames";

export class PaginationOld extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let limit = this.props.limit;
        let offset = this.props.offset;
        let count = this.props.count;

        // Calculate the page variables
        let maxPages = Math.ceil(count / limit);
        let currentPage = (offset + limit) / limit;

        let numbers = [];

        if (maxPages > 1) {
            // The previous button
            let previousClass = classNames("page-item page-item--nav", { disabled: currentPage == 1 });
            numbers.push(
                <li
                    key="prev"
                    className={previousClass}
                    onClick={() => {
                        if (currentPage > 1) this.props.pageSwitch((currentPage - 2) * limit);
                    }}
                >
                    <span className="page-link">Vorige</span>
                </li>
            );

            // Numbers buttons
            for (let i = 1; i <= maxPages; i++) {
                let currentClass = classNames("page-item", { active: i == currentPage });
                numbers.push(
                    <li key={"number" + i} className={currentClass} onClick={() => this.props.pageSwitch(i * limit - limit)}>
                        <span className="page-link">{i}</span>
                    </li>
                );
            }

            // The next button
            let nextClass = classNames("page-item page-item--nav", { disabled: currentPage == maxPages });
            numbers.push(
                <li
                    key="next"
                    className={nextClass}
                    onClick={() => {
                        if (currentPage < maxPages) this.props.pageSwitch(currentPage * limit);
                    }}
                >
                    <span className="page-link">Volgende</span>
                </li>
            );

            return (
                <nav aria-label="Page navigation example">
                    <ul className="pagination text-center">{numbers}</ul>
                </nav>
            );
        } else {
            return <div></div>;
        }
    }
}

export default function Pagination(props) {
    const [limit, setLimit] = useState(props?.limit || 20);
    const [offset, setOffset] = useState(props?.offset || 0);
    const [count, setCount] = useState(0);

    const [maxPages, setMaxPages] = useState(0);
    // The current page is determined by the result offset, assuming the offset is 40 and the page size is 20, the current page is 60 / 20 = 3
    const [currentPage, setCurrentPage] = useState((offset + limit) / limit || 0);
    const [pageInput, setPageInput] = useState(currentPage);

    // Seperate effect for the count since its not supplied initially
    useEffect(() => {
        if (props.count > 0) {
            setCount(props.count);
        }
    }, [props.count]);

    useEffect(() => {
        setPageInput(currentPage);
    }, [currentPage]);

    useEffect(() => {
        if (props.count > 0) {
            // Pages are determined by all results divided by the result page size
            setMaxPages(Math.ceil(props.count / limit));
        }
    }, [count, limit, offset]);

    const handleChange = (event) => {
        setPageInput(parseInt(event.target.value));

        if (event.key === "Enter") {
            _setPage(event.target.value);
        }
    };

    const _setPage = (page) => {
        let receivedPage = parseInt(page);

        // First 'normalize' the received page
        if (receivedPage <= 0) {
            receivedPage = 1;
        } else if (receivedPage > maxPages) {
            receivedPage = maxPages;
        }

        // Only switch page when it's necessary
        if (receivedPage !== currentPage) {
            // If we want the results for page 5 we need to provide the required offset.
            // In this case that would be (5 * 20) - 20 = 80.
            // This will return the results 80 - 100
            props.pageSwitch(receivedPage * limit - limit);
        }

        setCurrentPage(receivedPage);
    };

    return (
        <nav aria-label="Page navigation example">
            {(maxPages > 1 || props?.displayFake === true) && (
                <div className="pagination text-center">
                    <button key="first" className={cx("pagination-item", { disabled: currentPage === 1 })} onClick={() => _setPage(1)}>
                        Eerste
                    </button>

                    <div className="pagination-main">
                        <button
                            key="prev"
                            className={cx("pagination-item pagination-item--previous", { disabled: currentPage === 1 })}
                            onClick={() => _setPage(currentPage - 1)}
                        >
                            <i className="fa fa-angle-left" /> Vorige
                        </button>

                        {props?.displaySummary === true ? (
                            <div key="summary" className="pagination-summary">
                                {currentPage} van {maxPages}
                                <br />({props.count} resultaten)
                            </div>
                        ) : (
                            <div key="current" className="pagination-jumpto">
                                <div className="pagination-jumpto__section">
                                    <input
                                        className="text-filter pagination-jumpto__input"
                                        placeholder={currentPage}
                                        value={pageInput}
                                        type="number"
                                        onChange={handleChange}
                                        onKeyPress={handleChange}
                                    />
                                    <span className="pagination-jumpto__total">van {maxPages}</span>
                                </div>
                                <button className="pagination-item pagination-item--jumpto" onClick={() => _setPage(pageInput)}>
                                    Ga
                                </button>
                            </div>
                        )}

                        <button
                            key="next"
                            className={cx("pagination-item pagination-item--next", { disabled: currentPage === maxPages })}
                            onClick={() => _setPage(currentPage + 1)}
                        >
                            Volgende <i className="fa fa-angle-right" />{" "}
                        </button>
                    </div>

                    <button key="last" className={cx("pagination-item", { disabled: currentPage === maxPages })} onClick={() => _setPage(maxPages)}>
                        Laatste
                    </button>
                </div>
            )}
        </nav>
    );
}
